export default __webpack_public_path__ + "static/mondrian-441aee88d7b03f19b63f8bd13c864d44.gif";